<script>
import BCKeyAssignmentMenu from './BCKeyAssignmentMenu.vue'

export default {
  name: 'BCKeyAssignmentExtendedMenuViewer',
  components: {
    BCKeyAssignmentMenu,
  },
  props: {
    setting: {
      type: Object,
      required: true,
    },
  },
}
</script>

<template>
  <BCKeyAssignmentMenu keyType="extendedMenu" :setting="setting" />
</template>
